module.exports = __webpack_public_path__ + "static/media/handle.1fe8b454.png";